export enum ProductAreaNo {
  Assembly = '9721',
  PlanningAndMeasurement = '9731',
  Delivery = '9711',
  RemovalAndRecycling = '9714',
  Installation = '9722',
  AssemblyAndInstallationAccommodation = '9792',
}
